import React from 'react';

import { unit } from '@zego/theme';

import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import SubItemsSection from '@zego/components/SubItemsSection';

import FlexiblePrivateHire from '@zego/static/images/graphics/FlexiblePrivateHire.svg';
import NoFees from '@zego/static/images/graphics/NoFees.svg';
import SDP from '@zego/static/images/graphics/SDP.svg';

const POLICY_BENEFITS = {
  title: 'What can I do with a Zego\nPrivate Hire policy?',
  description:
    'Zego’s Private Hire insurance covers you for the following activities:',
  items: [
    {
      title: 'Private Hire',
      description:
        'You can work as a Private Hire driver and transport passengers.',
      image: FlexiblePrivateHire,
    },
    {
      title: 'Hire & Reward',
      description:
        'You can work as a delivery driver, and deliver parcels and food.',
      image: NoFees,
    },
    {
      title: 'Social, Domestic & Pleasure',
      description:
        "You can drive your car when you're not working, using your vehicle for everyday trips and journeys.",
      image: SDP,
    },
  ],
};

const PrivateHirePolicyBenefits = () => (
  <View>
    <Spacer height={unit(10)} mobileHeight={unit(7)} />
    <SubItemsSection {...POLICY_BENEFITS} />
    <Spacer height={unit(10)} mobileHeight={unit(9)} />
  </View>
);

export default PrivateHirePolicyBenefits;
